<template>
  <div class="global-docu-list">
    <v-row class="ma-0">
      <v-col cols="12">
        <h2 class="primary--text font-weight-bold pt-5 pl-2">
          <v-icon color="primary" large left>
          </v-icon>
          {{ $t('common:documentation_plural') }}
        </h2>

        <DataTablePaginated
            ref="table"
            class="ma-1"
            :headers="headers"
            icon="edit"
            icon2="delete"
            @clickedButton1="openDocumentForm"
            @clickedButton2="deleteWindowOpen"
            @updateTableData="updateTable"
            :addBtn="true"
            @clickedAddButton="openDocumentForm"
            :addBtnText="$t('buttons:add-specific', { specific: $t('common:documentation')})"
            sortBy="createdAt"
            sort-desc
            :filterName="isAdmin ? `documentation` : null"
        />
      </v-col>
    </v-row>
    <FacilityDocuDialogForm
        ref="docuForm"
        :is-global="true"
        @updateDocuData="callUpdateTable"
    />
    <TwoButtonDialog
        ref="deleteButton"
        :dialog-title="$t('dialog:delete-btn-title', {name : $t('common:documentation')})"
        :dialog-text="$t('dialog:delete-btn-dialog', {name : $t('common:documentation')})"
        :button1-text="$t('buttons:cancel')"
        :button2-text="$t('buttons:delete')"
        :hideButton="true"
        @clickedButton1="$refs.deleteButton.showDialog = false"
        @clickedButton2="deleteDocumentation"
    />
  </div>
</template>

<script>
import DataTablePaginated from '@/modules/core/components/DataTable/DataTablePaginated.vue';
import Utils from '@/modules/core/services/utils';
import GlobalDocumentationService from '@/modules/book/services/global-documentation-service';
import TwoButtonDialog from '@/modules/core/components/TwoButtonDialog/TwoButtonDialog';
import FacilityDocuDialogForm from '@/modules/book/views/facility/facility/formDialogs/FacilityDocuDialogForm';

export default {
  name: "DocumentationList",
  components: {
    FacilityDocuDialogForm,
    DataTablePaginated,
    TwoButtonDialog
  },
  data() {
    return {
      showAll: false,
      currentDocumentation: {},
      tableConfigs: {
        options: {},
        search: ""
      }
    };
  },
  computed: {
    headers() {
      return [
        { text: this.$t('common:documentation'), value: 'name' },
        { text: this.$t('common:assigned-to'), sortable: false, cellClass: 'facilitylist-name', value: 'facilitiesName' },
        { text: "", value: "controls", sortable: false, align: 'end' },
        {
          text: this.$t('common:customer'),
          value: 'customer',
          filter: {
            type: 'searchable-select',
            group: 0,
            order: 0,
            url: 'customer/all-customers'
          },
          hide: true
        },
      ]
    },
    isAdmin() {
      return this.$store.getters["auth/isAdmin"];
    }
  },
  mounted() {
    if (this.$route.query.resourceId) {
      this.$refs.table.search = this.$route.query.resourceId;
    }
  },
  methods: {
    openDocumentForm(item) {
      if (item && item.id) {
        this.editContract(item);
      } else {
        this.$refs.docuForm.addDocu(this.tableConfigs.options, this.tableConfigs.search);
      }
    },
    updateTable(options, search, filter) {
      if (!search) search = '';

      this.tableConfigs.options = options;
      this.tableConfigs.search = search;
      this.$refs.table.loading = true;

      GlobalDocumentationService.readPageableDocumentationsFromAPI(
          options.page - 1,
          options.itemsPerPage,
          search,
          options.sortBy,
          options.sortDesc,
          filter,
          (response) => {
            if (this.$refs.table !== undefined) {
              this.$refs.table.fillTableData(response.data);
            }
            this.$refs.table.loading = false;
          },
          () => {
            this.$refs.table.loading = false;
            Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:documentation_plural')}));
          }
      )
    },
    updateFilter(value) {
      this.showAll = value;
      this.$refs.table.callTableUpdate()
    },
    editContract(item) {
      GlobalDocumentationService.getFacilityBuildInfo(
          item.id,
          (response) => {
            this.$refs.docuForm.editGlobalDocumentation(
                response.data,
                item,
                this.tableConfigs.options,
                this.tableConfigs.search
            );
          },
          (error) => {
            console.log(error);
            Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:documentation')}))
          }
      );
    },
    callUpdateTable() {
      if (!this.$refs.table) return;
      this.$refs.table.callTableUpdate();
    },
    deleteWindowOpen(docu) {
      this.currentDocumentation = docu;
      this.$refs.deleteButton.showDialog = true;
    },
    deleteDocumentation() {
      GlobalDocumentationService.deleteGlobalDoc(
          this.currentDocumentation.id,
          () => {
            Utils.showSuccessSnackbar(this.$t('snackbar:delete-success', {name: this.$t('common:documentation')}));
            this.callUpdateTable();
            this.currentDocumentation = {};
            this.$refs.deleteButton.showDialog = false;
          },
          () => {
            Utils.showFailureSnackbar(this.$t('snackbar:delete-failure', {name: this.$t('common:documentation')}));
            this.currentDocumentation = {};
            this.$refs.deleteButton.showDialog = false;
          }
      );
    }
  }
}
</script>

<style lang="scss">
.global-docu-list {
  .facilitylist-name {
    width: 75%;
  }

  .container.table-filter-container .col-md-3.col-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
</style>